import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { routes } from '../../MainPage'
function DetailHeader({ diseaseName }) {
  let navigate = useNavigate();

  return (
    <div className="web-sect pageBox">
      <div className="pageBanner">
        <div className="page-banner-wrap">
          <div className="pageWrapperItem">
            <img
              src={require("../../img/banner-bg.png")}
              alt="Page Banner"
            />
            <div className="pageBanner-text">
              <div className="container">
                <div className="pageBanner-content">
                  <h1>{diseaseName}</h1>
                  <div className="breadcrumbs">
                    <div className="container">
                      <ul className="list-inline listUnstyle">
                        <li>
                          <a onClick={() => navigate(routes.home)}
                            href='javascript:void(0)'>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 32 32"
                            >
                              <path d="m21.82 30h-11.64a5 5 0 0 1 -5.18-4.76v-6.24a1 1 0 0 1 2 0v6.24a3 3 0 0 0 3.18 2.76h11.64a3 3 0 0 0 3.18-2.76v-6.24a1 1 0 0 1 2 0v6.24a5 5 0 0 1 -5.18 4.76zm7.89-13.29a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0 -1.42 0l-13 13a1 1 0 0 0 1.42 1.42l12.29-12.3 12.29 12.3a1 1 0 0 0 1.42 0z" />
                            </svg>
                            Home
                          </a>
                        </li>
                        <li>
                          <a onClick={() => navigate(routes.disease)}
                            href={routes.disease}>
                            Disease
                          </a>
                        </li>
                        <li>
                          <span>{diseaseName}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailHeader;